import {BaseResponse} from './internal/baseresponse';
import {UserList, ReceiverList, CustomerList} from './internal/list/userlist';


export class UserListResult extends BaseResponse {
  data: UserList;
}


export class CustomerListResult extends BaseResponse {
  data: CustomerList;
}

export class ReceiverListResult extends BaseResponse {
  data: ReceiverList;
}



// WEBPACK FOOTER //
// ./src/app/response/userlistresult.ts